import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardTitle, Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import ReactQuill from 'react-quill';
import '../styles/createPackage.css';
import { toast } from 'react-toastify';

const CreatePackage = () => {
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedVendor, setSelectedVendor] = useState('');
  const [city, setCity] = useState('');
  const [duration, setDuration] = useState('');
  const [price, setPrice] = useState('');
  const [price_discount, setPrice_discount] = useState('');
  const [highlights, setHighlights] = useState('');
  const [included, setIncluded] = useState('');
  const [notIncluded, setNotIncluded] = useState('');
  const [requirement, setRequirement] = useState('');
  const [bookingPolicy, setBookingPolicy] = useState('');
  const [cancellationPolicy, setCancellationPolicy] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [bannerImageFile, setBannerImageFile] = useState(null);
  const [roomSharing, setRoomSharing] = useState('');
  const [roomDetails, setRoomDetails] = useState('');
  const [departurePoint, setDeparturePoint] = useState('');
  const [departureDate, setDepartureDate] = useState('');
  const [departureDetails, setDepartureDetails] = useState('');
  const [arrivalPoint, setArrivalPoint] = useState('');
  const [arrivalDate, setArrivalDate] = useState('');
  const [arrivalDetails, setArrivalDetails] = useState('');
  const [numberOfDays, setNumberOfDays] = useState('');
  const [daysDetails, setDaysDetails] = useState('');
  const [airline, setAirline] = useState('');
  const [airlineDetails, setAirlineDetails] = useState('');
  const [visa, setVisa] = useState('');
  const [visaDetails, setVisaDetails] = useState('');
  const [transfer, setTransfer] = useState('');
  const [transferDetails, setTransferDetails] = useState('');
  const [food, setFood] = useState('');
  const [foodDetails, setFoodDetails] = useState('');
  const [sightseeing, setSightseeing] = useState('');
  const [sightseeingDetails, setSightseeingDetails] = useState('');
  const [distanceFromKaba, setDistanceFromKaba] = useState('');
  const [kabaDetails, setKabaDetails] = useState('');
  const [distanceFromRawda, setDistanceFromRawda] = useState('');
  const [rawdaDetails, setRawdaDetails] = useState('');
  const [open, setOpen] = useState('1');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await api.get('/category/get-all');
      setCategories(response.data.data);
    };

    const fetchVendors = async () => {
      const response = await api.get('/vendor/get-all');
      setVendors(response.data.data);
    };

    fetchCategories();
    fetchVendors();
  }, []);

  const validateImageDimensions = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        if (image.width <= maxWidth && image.height <= maxHeight) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      image.onerror = () => {
        reject(new Error('Invalid image file.'))
      };
      image.src = URL.createObjectURL(file);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    if (!selectedVendor) errors.selectedVendor = "Select a Service Provider";
    if (!selectedCategory) errors.selectedCategory = "Select a category";
    if (!city.trim()) errors.city = "City cannot be empty";
    if (!duration.trim()) errors.duration = "Duration cannot be empty";
    if (!price.trim()) errors.price = "Price cannot be empty";
    if (!roomSharing) errors.roomSharing = "Select room sharing";
    if (!departureDate) errors.departureDate = "Departure date cannot be empty";
    if (!arrivalDate) errors.arrivalDate = "Arrival date cannot be empty";

    const allowedImageTypes = ["image/png", "image/jpeg"];
    if (!imageFile) {
      errors.imageFile = "Package Image cannot be empty, only PNG and JPG files are allowed";
    } else if (!allowedImageTypes.includes(imageFile.type)) {
      errors.imageFile = "Only PNG and JPG files are allowed";
    } else {
      // const isValidImage = await validateImageDimensions(imageFile, 251, 168);
      // if (!isValidImage) {
      //   errors.imageFile = "Package Image must be under 251px by 168px"
      // }
    }

    if (!bannerImageFile) {
      errors.bannerImageFile = "Banner Image cannot be empty, only PNG and JPG files are allowed";
    } else if (!allowedImageTypes.includes(bannerImageFile.type)) {
      errors.bannerImageFile = "Only PNG and JPG files are allowed";
    } else {
      // const isValidBanner = await validateImageDimensions(bannerImageFile, 904, 472);
      // if (!isValidBanner) {
      //   errors.bannerImageFile = 'Banner Image must be under 251px by 168px';
      // }
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    setErrors({});

    const formData = new FormData();
    formData.append('city', city);
    formData.append('duration', duration);
    formData.append('price', price);
    formData.append('price_discount', price_discount);
    formData.append('highlights', highlights);
    formData.append('included', included);
    formData.append('not_included', notIncluded);
    formData.append('requirement', requirement);
    formData.append('booking_policy', bookingPolicy);
    formData.append('cancellation_policy', cancellationPolicy);
    formData.append('image_path', imageFile);
    formData.append('banner_image_path', bannerImageFile);
    formData.append('category_id', selectedCategory);
    formData.append('vendor_id', selectedVendor);
    formData.append('room_sharing', roomSharing);
    formData.append('room_details', roomDetails);
    formData.append('departure_point', departurePoint);
    formData.append('departure_details', departureDetails);
    formData.append('arrival_point', arrivalPoint);
    formData.append('departure_date', departureDate);
    formData.append('arrival_date', arrivalDate);
    formData.append('arrival_details', arrivalDetails);
    formData.append('number_of_days', numberOfDays);
    formData.append('days_details', daysDetails);
    formData.append('airline', airline);
    formData.append('airline_details', airlineDetails);
    formData.append('visa', visa);
    formData.append('visa_details', visaDetails);
    formData.append('transfer', transfer);
    formData.append('transfer_details', transferDetails);
    formData.append('food', food);
    formData.append('food_details', foodDetails);
    formData.append('sightseeing', sightseeing);
    formData.append('sightseeing_details', sightseeingDetails);
    formData.append('distance_from_kaba', distanceFromKaba);
    formData.append('kaba_details', kabaDetails);
    formData.append('distance_from_rawda', distanceFromRawda);
    formData.append('rawda_details', rawdaDetails);

    try {
      const response = await api.post('/product/add', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 200) {
        toast.success('Package created successfully!');
        navigate('/manage-package', { replace: true });
        
      } else {
        toast.error('Failed to create package');
      }
    } catch (error) {
      console.error('Error creating package:', error);
      toast.error('Error creating package ' + error.response.data);
    }
  };

  const handleCancel = () => {
    setSelectedCategory('');
    setSelectedVendor('');
    setCity('');
    setDuration('');
    setPrice('');
    setHighlights('');
    setIncluded('');
    setNotIncluded('');
    setRequirement('');
    setBookingPolicy('');
    setCancellationPolicy('');
    setImageFile(null);
    setBannerImageFile(null);
    setRoomSharing('');
    setRoomDetails('');
    setDeparturePoint('');
    setDepartureDate('');
    setDepartureDetails('');
    setArrivalPoint('');
    setArrivalDate('');
    setArrivalDetails('');
    setNumberOfDays('');
    setDaysDetails('');
    setAirline('');
    setAirlineDetails('');
    setVisa('');
    setVisaDetails('');
    setTransfer('');
    setTransferDetails('');
    setFood('');
    setFoodDetails('');
    setSightseeing('');
    setSightseeingDetails('');
    setDistanceFromKaba('');
    setKabaDetails('');
    setDistanceFromRawda('');
    setRawdaDetails('');
    navigate('/manage-package');
  };

  const toggle = (id) => {
    if (open === id) {
      setOpen("0");
    } else {
      setOpen(id);
    }
  };

  return (
    <div className='container mt-3 mb-5'>
      <CardTitle tag="h5" className="mb-3">
        Package List <span style={{ color: '#B0B0B0' }}>/ Add Card</span>
      </CardTitle>
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <Accordion open={open} toggle={toggle}>

              {/* Basic Details Section */}
              <AccordionItem className='mb-4'>
                <AccordionHeader targetId="1">Basic Details</AccordionHeader>
                <AccordionBody accordionId="1">
                  <div className='col-xl-8'>
                    <div className='mb-3'>
                      <label className='form-label'>Vendor *</label>
                      <select className={`form-control ${errors.selectedVendor ? 'is-invalid' : ''}`} value={selectedVendor} onChange={(e) => setSelectedVendor(e.target.value)}  >
                        <option value=''>Select Vendor</option>
                        {vendors.map((vendor) => (
                          <option key={vendor.id} value={vendor.id} >
                            {vendor.name}
                          </option>
                        ))}
                      </select>
                      <b>{errors.selectedVendor && <span className='text-danger small'>{errors.selectedVendor}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Category *</label>
                      <select className={`form-control ${errors.selectedCategory ? 'is-invalid' : ''}`} value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}  >
                        <option value="">Select Category</option>
                        {categories.map((category) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                      <b>{errors.selectedCategory && <span className='text-danger small'>{errors.selectedCategory}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>City *</label>
                      <input type="text" className={`form-control ${errors.city ? 'is-invalid' : ''}`} value={city} onChange={(e) => setCity(e.target.value)} placeholder="Enter City" />
                      <b>{errors.city && <span className='text-danger small'>{errors.city}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Duration *</label>
                      <input type="text" className={`form-control ${errors.duration ? 'is-invalid' : ''}`} value={duration} onChange={(e) => setDuration(e.target.value)} placeholder="Enter Duration" />
                      <b>{errors.duration && <span className='text-danger small'>{errors.duration}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Price *</label>
                      <input type="number" className={`form-control ${errors.price ? 'is-invalid' : ''}`} value={price} onChange={(e) => setPrice(e.target.value)} placeholder="Enter Price" />
                      <b>{errors.price && <span className='text-danger small'>{errors.price}</span>}</b>
                    </div>
                     <div className='mb-3'>
                      <label className='form-label'>Discount in Price(only in %)*</label>
                      <input type="number" className={`form-control ${errors.price_discount ? 'is-invalid' : ''}`} value={price_discount} onChange={(e) => setPrice(e.target.value)} placeholder="Enter Discount (%)" />
                      <b>{errors.price_discount && <span className='text-danger small'>{errors.price_discount}</span>}</b>
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>

              {/* Card Details Section */}
              <AccordionItem className='mb-4'>
                <AccordionHeader targetId="2">Card Details</AccordionHeader>
                <AccordionBody accordionId="2">
                  <div className='col-xl-8'>
                    <div className="mb-3">
                      <label className='form-label'>Highlights * </label>
                      <ReactQuill value={highlights} onChange={setHighlights} className='' placeholder='Description...' />
                    </div>
                    <div className="mb-3">
                      <label className='form-label'>What's Included * </label>
                      <ReactQuill value={included} onChange={setIncluded} className='' placeholder='Description...' />
                    </div>
                    <div className="mb-3">
                      <label className='form-label'>What's Not Included * </label>
                      <ReactQuill value={notIncluded} onChange={setNotIncluded} className='' placeholder='Description...' />
                    </div>
                    <div className="mb-3">
                      <label className='form-label'>Requirement * </label>
                      <ReactQuill value={requirement} onChange={setRequirement} className='' placeholder='Description...' />
                    </div>
                    <div className="mb-3">
                      <label className='form-label'>Booking Policy * </label>
                      <ReactQuill value={bookingPolicy} onChange={setBookingPolicy} className='' placeholder='Description...' />
                    </div>
                    <div className="mb-3">
                      <label className='form-label'>Cancellation Policy * </label>
                      <ReactQuill value={cancellationPolicy} onChange={setCancellationPolicy} className='' placeholder='Description...' />
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>

              {/* Other Details Section */}
              <AccordionItem className='mb-4'>
                <AccordionHeader targetId="3">Other Details</AccordionHeader>
                <AccordionBody accordionId="3">
                  <div className='col-xl-8'>
                    <div className='mb-3'>
                      <label className='form-label'>Room Sharing * </label>
                      <select className={`form-control ${errors.roomSharing ? 'is-invalid' : ''}`} value={roomSharing} onChange={(e) => setRoomSharing(e.target.value)}>
                        <option value=''>Select room sharing</option>
                        <option value="single">Single</option>
                        <option value="double">Double</option>
                        <option value="triple">Triple</option>
                        <option value="quad">Quad</option>
                        <option value="five">Five</option>
                        <option value="six">Six</option>
                      </select>
                      <b>{errors.roomSharing && <span className='text-danger small'>{errors.roomSharing}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Room Details * </label>
                      <ReactQuill className='' value={roomDetails} onChange={setRoomDetails} placeholder='Description...' />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Departure Point * </label>
                      <input type="text" className='form-control' value={departurePoint} onChange={(e) => setDeparturePoint(e.target.value)} placeholder="Departure Point" />

                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Departure Date * </label>
                      <input type="date" className={`form-control ${errors.departureDate ? 'is-invalid' : ''}`} value={departureDate} onChange={(e) => setDepartureDate(e.target.value)} />
                      <b>{errors.departureDate && <span className='text-danger small'>{errors.departureDate}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Departure Details * </label>
                      <ReactQuill className='' value={departureDetails} onChange={setDepartureDetails} placeholder='Description...' />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Arrival Point * </label>
                      <input type="text" className="form-control " value={arrivalPoint} onChange={(e) => setArrivalPoint(e.target.value)} placeholder="Arrival Point" />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Arrival Date * </label>
                      <input type="date" className={`form-control ${errors.arrivalDate ? 'is-invalid' : ''}`} value={arrivalDate} onChange={(e) => setArrivalDate(e.target.value)} />
                      <b>{errors.arrivalDate && <span className='text-danger small'>{errors.arrivalDate}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Arrival Details * </label>
                      <ReactQuill className='' value={arrivalDetails} onChange={setArrivalDetails} placeholder='Description...' />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Number of Days * </label>
                      <input type="number" className='form-control' value={numberOfDays} onChange={(e) => setNumberOfDays(e.target.value)} placeholder="Enter number of Days" />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Days Details * </label>
                      <ReactQuill className='' value={daysDetails} onChange={setDaysDetails} placeholder='Description...' />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Airline * </label>
                      <input type="text" className="form-control " value={airline} onChange={(e) => setAirline(e.target.value)} placeholder="Enter Airline" />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Airline Details * </label>
                      <ReactQuill className='' value={airlineDetails} onChange={setAirlineDetails} placeholder="Description..." />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Visa * </label>
                      <input type="text" className="form-control " value={visa} onChange={(e) => setVisa(e.target.value)} placeholder="Enter Visa" />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Visa Details * </label>
                      <ReactQuill className='' value={visaDetails} onChange={setVisaDetails} placeholder="Description..." />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Transfer * </label>
                      <input type="text" className="form-control " value={transfer} onChange={(e) => setTransfer(e.target.value)} placeholder="Enter Transfer" />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Transfer Details * </label>
                      <ReactQuill className='' value={transferDetails} onChange={setTransferDetails} placeholder="Description..." />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Food * </label>
                      <input type="text" className="form-control " value={food} onChange={(e) => setFood(e.target.value)} placeholder="Enter Food" />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Food Details * </label>
                      <ReactQuill className='' value={foodDetails} onChange={setFoodDetails} placeholder="Description..." />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Sightseeing * </label>
                      <input type="text" className="form-control " value={sightseeing} onChange={(e) => setSightseeing(e.target.value)} placeholder="Enter Sightseeing" />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Sightseeing Details * </label>
                      <ReactQuill className='' value={sightseeingDetails} onChange={setSightseeingDetails} placeholder="Description..." />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Distance from Kaba * </label>
                      <input type="text" className="form-control " value={distanceFromKaba} onChange={(e) => setDistanceFromKaba(e.target.value)} placeholder="Enter Distance in km" />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Kaba Details * </label>
                      <ReactQuill className='' value={kabaDetails} onChange={setKabaDetails} placeholder="Description..." />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Distance from Rawda * </label>
                      <input type="text" className="form-control " value={distanceFromRawda} onChange={(e) => setDistanceFromRawda(e.target.value)} placeholder="Enter Distance in km" />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Rawda Details * </label>
                      <ReactQuill className='' value={rawdaDetails} onChange={setRawdaDetails} placeholder="Description..." />
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>

              {/* Upload Image Section */}
              <AccordionItem className='mb-4'>
                <AccordionHeader targetId="4">Upload Image</AccordionHeader>
                <AccordionBody accordionId="4">
                  <div className='col-xl-8'>
                    <div className="mb-3">
                      <label className='form-label'>Package Image * (only png and Jpg size 251px*168px)</label>
                      <input type="file" className={`form-control ${errors.imageFile ? 'is-invalid' : ''}`} onChange={(e) => setImageFile(e.target.files[0])} />
                      <b>{errors.imageFile && <span className="text-danger small">{errors.imageFile}</span>}</b>
                    </div>
                    <div className="mb-3">
                      <label className='form-label'>Banner Image * (only png and Jpg size 251px*168px) </label>
                      <input type="file" className={`form-control ${errors.bannerImageFile ? 'is-invalid' : ''}`} onChange={(e) => setBannerImageFile(e.target.files[0])} />
                      <b>{errors.bannerImageFile && <span className='text-danger small'>{errors.bannerImageFile}</span>}</b>
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <div className="button-group">
                <button type="submit" className="btn btn-success submit-button">Create</button>
                <button type="button" className="btn btn-danger cancel-button" onClick={handleCancel}>Cancel</button>
              </div>

            </Accordion>
          </form>
        </CardBody>
      </Card>

    </div>
  );
};

export default CreatePackage;
